import React from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { faThumbTack } from '@fortawesome/free-solid-svg-icons';
import useCustomTheme from '../../../hooks/theme-hook';
import useTranslation from '../../../hooks/translation-hook';
import { useAppSelector } from '../../../hooks/store-hook';
import Label from '../Label';

interface Props {
  count: number;
  onPress(): void;
}

export default function PinnedMissionsButton({ count, onPress }: Props) {
  const theme = useCustomTheme();
  const t = useTranslation();
  const language = useAppSelector(state => state.userPrefs.uiLanguage);
  const label = t('Featured-missions', {
    defaultValue: language?.startsWith('fr') ? 'Missions en vedette' : 'Featured missions',
  });

  return (
    <Pressable
      testID="pinned-missions-button"
      accessibilityRole="button"
      accessibilityLabel={label}
      accessibilityValue={{ text: `${count}` }}
      onPress={onPress}
      style={({ pressed }) => [styles.button, { backgroundColor: theme.primary, opacity: pressed ? 0.85 : 1 }]}
    >
      <FontAwesomeIcon icon={faThumbTack} size={18} color="#025164" />
      <Label style={styles.label}>{label}</Label>
      <View style={styles.badge}>
        <Label style={styles.count}>{count}</Label>
      </View>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  button: {
    alignSelf: 'flex-end',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    maxWidth: '100%',
    minHeight: 48,
    marginTop: 12,
    paddingHorizontal: 14,
    paddingVertical: 10,
    borderRadius: 24,
    borderWidth: 2,
    borderColor: 'white',
    shadowColor: '#001f29',
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 0.25,
    shadowRadius: 6,
    elevation: 6,
  },
  label: { color: '#025164', fontSize: 14, fontWeight: '700', flexShrink: 1 },
  badge: {
    minWidth: 24,
    minHeight: 24,
    paddingHorizontal: 6,
    borderRadius: 12,
    backgroundColor: '#025164',
    alignItems: 'center',
    justifyContent: 'center',
  },
  count: { color: 'white', fontSize: 12, fontWeight: '700' },
});
